<!-- <ion-app *ngIf="securedPage && !communePage && !conseilPages">
  <ion-split-pane when="false" contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" *ngIf="!elu.epci_id">
      <ion-content>
        <ion-list id="inbox-list">
          <ion-list-header>Bonjour {{ elu.prenom }}</ion-list-header>
          <ion-note>{{ elu.email }}</ion-note>

          <ion-menu-toggle
            auto-hide="false"
            *ngFor="let p of appPages; let i = index"
          >
            <ion-item
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
            >
              <ion-icon
                aria-hidden="true"
                slot="start"
                [ios]="p.icon"
                [md]="p.icon + '-sharp'"
              ></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
      <ion-item class="deleteAcc">
        <ion-button
          fill="clear"
          class="deleteAccBtn"
          expand="block"
          (click)="setOpen(true)"
        >
          Supprimer mon compte et mes données</ion-button
        >
      </ion-item>
      <ion-item class="logout">
        <ion-button
          expand="block"
          fill="clear"
          (click)="logout()"
          class="linkBtn"
        >
          <ion-icon slot="start" name="log-out-outline"></ion-icon>
          <ion-label>Se déconnecter</ion-label>
        </ion-button>
      </ion-item>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app> -->

<!-- <ion-app *ngIf="securedPage && (communePage || conseilPages)"> -->
<ion-app *ngIf="securedPage">
  <ion-split-pane when="false" contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-content>
        <ion-list id="inbox-list" lines="none">
          <ion-list-header>Bonjour {{ elu.prenom }}</ion-list-header>
          <ion-note>{{ elu.email }}</ion-note>

          <ng-container *ngIf="communePages">
            <ion-menu-toggle
              auto-hide="false"
              *ngFor="let p of communePages; let i = index"
            >
              <!-- <ion-item-divider *ngIf="p.title === 'Fibre' || p.title === 'Application'">
              <ion-label></ion-label>
            </ion-item-divider> -->
              <hr *ngIf="p.title === 'Fibre' || p.title === 'Application'" />
              <ion-item
                routerDirection="root"
                [routerLink]="[p.url]"
                [routerLinkActiveOptions]="{ exact: true }"
                lines="none"
                detail="false"
                routerLinkActive="selected"
                [class.mainTitle]="
                  p.title === 'Fibre' || p.title === 'Application'
                "
                [class.disabled]="p.disabled"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  [ios]="p.icon"
                  [md]="p.icon"
                ></ion-icon>
                <!-- <ion-label *ngIf="p.title === 'Fibre' || p.title === 'Application'" class="mainTitle">{{ p.title }}</ion-label> -->
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
          <ng-container *ngIf="conseilPages">
            <ion-menu-toggle
              auto-hide="false"
              *ngFor="let p of conseilPages; let i = index"
            >
              <!-- <ion-item-divider *ngIf="p.title === 'Fibre' || p.title === 'Application'">
              <ion-label></ion-label>
            </ion-item-divider> -->
              <hr *ngIf="p.title === 'Fibre' || p.title === 'Application'" />
              <ion-item
                routerDirection="root"
                [routerLink]="[p.url]"
                [routerLinkActiveOptions]="{ exact: true }"
                lines="none"
                detail="false"
                routerLinkActive="selected"
                [class.mainTitle]="
                  p.title === 'Fibre' || p.title === 'Application'
                "
                [class.disabled]="p.disabled"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  [ios]="p.icon"
                  [md]="p.icon"
                ></ion-icon>
                <!-- <ion-label *ngIf="p.title === 'Fibre' || p.title === 'Application'" class="mainTitle">{{ p.title }}</ion-label> -->
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
          <ng-container *ngIf="appPages">
            <ion-menu-toggle
              auto-hide="false"
              *ngFor="let p of appPages; let i = index"
            >
              <!-- <ion-item-divider *ngIf="p.title === 'Fibre' || p.title === 'Application'">
              <ion-label></ion-label>
            </ion-item-divider> -->
              <hr *ngIf="p.title === 'Fibre' || p.title === 'Application'" />
              <ion-item
                routerDirection="root"
                [routerLink]="[p.url]"
                [routerLinkActiveOptions]="{ exact: true }"
                lines="none"
                detail="false"
                routerLinkActive="selected"
                [class.mainTitle]="
                  p.title === 'Fibre' || p.title === 'Application'
                "
                [class.disabled]="p.disabled"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  [ios]="p.icon"
                  [md]="p.icon"
                ></ion-icon>
                <!-- <ion-label *ngIf="p.title === 'Fibre' || p.title === 'Application'" class="mainTitle">{{ p.title }}</ion-label> -->
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
        </ion-list>
      </ion-content>
      <div class="flex justify-center rs" *ngIf="linksRS">
        <ion-button
          *ngIf="linksRS.facebook"
          fill="clear"
          size="small"
          [href]="linksRS.facebook"
          target="_blank"
          ><ion-icon name="logo-facebook"></ion-icon
        ></ion-button>
        <ion-button
          *ngIf="linksRS.linkedin"
          fill="clear"
          size="small"
          [href]="linksRS.linkedin"
          target="_blank"
          ><ion-icon name="logo-linkedin"></ion-icon
        ></ion-button>
        <ion-button
          *ngIf="linksRS.twitter"
          fill="clear"
          size="small"
          [href]="linksRS.twitter"
          target="_blank"
          ><ion-icon name="logo-twitter"></ion-icon
        ></ion-button>
        <ion-button
          *ngIf="linksRS.instagram"
          fill="clear"
          size="small"
          [href]="linksRS.instagram"
          target="_blank"
          ><ion-icon name="logo-instagram"></ion-icon
        ></ion-button>
      </div>

      <ion-item class="deleteAcc">
        <ion-button
          fill="clear"
          class="deleteAccBtn"
          expand="block"
          (click)="setOpen(true)"
        >
          Supprimer mon compte et mes données</ion-button
        >
      </ion-item>
      <ion-item class="logout">
        <ion-button
          expand="block"
          fill="clear"
          (click)="logout()"
          class="linkBtn"
        >
          <ion-icon slot="start" name="log-out-outline"></ion-icon>
          <ion-label>Se déconnecter</ion-label>
        </ion-button>
      </ion-item>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>

<ion-app *ngIf="publicPage">
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>

<ion-modal [isOpen]="isModalOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Attention</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="setOpen(false)">Fermer</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding modalDel">
      <h2>Êtes-vous sûr de vouloir supprimer votre compte ?</h2>

      <p>
        Cette action est irréversible, vous ne pourrez plus vous connecter sur
        l’interface de {{ brandName }}.
      </p>
      <ion-item class="input-label">
        <ion-input
          type="text"
          [(ngModel)]="identifiant"
          fill="outline"
          label="Identifiant"
          label-placement="floating"
          color="primary"
        ></ion-input>
      </ion-item>

      <ion-item class="input-label">
        <ion-input
          type="password"
          [(ngModel)]="password"
          fill="outline"
          label="Mot de passe"
          label-placement="floating"
          color="primary"
        ></ion-input>
      </ion-item>

      <div class="flex justify-end">
        <ion-button expand="block" class="saveBtn" (click)="deleteAcc()">
          <ion-icon name="trash" class="mr-2"></ion-icon>
          <ion-label>Supprimer mon compte</ion-label>
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
